import { getEasasRestUrl } from "../utils/utils";

function toJson(response){
    return response.json()
}

export function ProductTemplateService(){
    const url = `${getEasasRestUrl()}/productTemplates/`;

    function get(endpoint){
        const path = url + endpoint;
        return fetch(path, { credentials: "same-origin" })
    }

    function put(endpoint, body){
        const path = url + endpoint;
        const headers = new Headers({'Content-Type': 'application/json'});
        return fetch(path, {
            method: "PUT",
            headers: headers,
            credentials: "same-origin",
            body: JSON.stringify(body)
        });
    }

    function post(endpoint, body){
        const path = url + endpoint;
        const headers = new Headers({'Content-Type': 'application/json'});
        return fetch(path, {
            method: "POST",
            headers: headers,
            credentials: "same-origin",
            body: JSON.stringify(body)
        });
    }

    function create(template) {
        return post("config", template).then(toJson);
    }

    function getConfig(refName) {
        return get(`${refName}/config`).then(toJson);
    }

    function updateConfig(refName, template){
        return put(`${refName}/config`, template).then(toJson);
    }

    return Object.freeze({
        create,
        getConfig,
        updateConfig,
    });
}

